import React from 'react'
import { apiFetch } from './fetchApi'

export const fetchEod = async  ({ BeURL, showAlert, setEodList, id }) => {
    try {
        const res = await apiFetch(`${BeURL}/fetch-eod-reports?currentuser=${id}`, {
            method: "GET",
            credentials: "include",
        });
        const data = await res.json();
        if (data.success) {
            setEodList(data?.eod)
            
        } else {
            showAlert(data.message);
        }
    } catch (err) {
        console.error("Error in fetch job:", err);
        showAlert("Failed to fetch jobs", "error");
    }
}
